<template>
  <ul v-if="config.pages.length" class="nav navbar-nav">
    <template v-for="(page,index) in pages">
      <!-- parent  -->
      <!-- dropdown -->
      <ApplicationMenuDropdown
        v-if="page.children"
        :key="'d' + index"
        v-bind="page"
        class="border-0"
        :textClass="textClass"
        :focused="showDropdownMenu && (shownDropdownMenuIndex == index)"
        @toggleDropdownMenu="toggleDropdownMenu(index)"
        @keyup.tab.native="showDropdownMenu=false"
      />
      <!-- dropdown menu -->
      <ApplicationMenuDropdownMenu
        v-if="page.children"
        :key="'md' + index"
        v-bind="page"
        class="mt-1_16 border-0"
        :textClass="textClass"
        :show="showDropdownMenu && (shownDropdownMenuIndex == index)"
      />
      <!-- lien -->
      <ApplicationMenuLink
        v-else
        :key="'li' + index"
        :page="page"
      />
    </template>
  </ul>
</template>


<script>
import ApplicationMenuConfig from "@clir/ApplicationMenu/ApplicationMenuConfig";
import ApplicationMenuLink from "@clir/ApplicationHeader/MobileTablet/ApplicationMenuLink";
import ApplicationMenuDropdown from "@clir/ApplicationHeader/MobileTablet/ApplicationMenuDropdown";
import ApplicationMenuDropdownMenu from "@clir/ApplicationHeader/MobileTablet/ApplicationMenuDropdownMenu";

export default {
  name: "ApplicationMenu",
  data() {
    return { showDropdownMenu: false, shownDropdownMenuIndex: 0 };
  },
  props: {
    config: { type: Object, default: () => ApplicationMenuConfig }
  },
  computed: {
    textClass() {
      return this.getKey(this.config, "style.textClass", "");
    },
    pages() {
      return this.getKey(this.config, "pages", []);
    }
  },
  watch: {
    $route() {
      this.showDropdownMenu = false;
    }
  },
  methods: {
    toggleDropdownMenu(index) {
      if (index === this.shownDropdownMenuIndex)
        this.showDropdownMenu = !this.showDropdownMenu;
      else {
        this.shownDropdownMenuIndex = index;
        this.showDropdownMenu = true;
      }
    }
  },
  components: {
    ApplicationMenuLink,
    ApplicationMenuDropdown,
    ApplicationMenuDropdownMenu
  }
};
</script>